import { useApiClient } from '../composables/useApiClient.ts';
import { FileToUpload } from '../types/FileToUpload.ts';
import { PuzzleTaxFile } from '../types/PuzzleTaxFile.ts';
import imageToPdf from '../procedures/image-to-pdf.ts';

export default {
    index(query: string = '') {
        return useApiClient().get(`files${ query }`);
    },
    show(id: number) {
        return useApiClient().get(`files/${ id }`);
    },
    update(file: PuzzleTaxFile) {
        return useApiClient().put(`files/${ file.id }`, file);
    },
    delete(id: number) {
        return useApiClient().delete(`files/${ id }`);
    },
    download(id: number) {
        return useApiClient().get(`files/download/${ id }`, { responseType: 'blob' });
    },
    async upload(file: FileToUpload) {
        await imageToPdf(file);
        const formData = new FormData();
        Object.entries(file).forEach(([ key, value ]) => formData.append(key, value));

        return useApiClient().post('files', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
};
